<div class="notification-wrapper">
    <div class="content-style">
        {{data.config}}  {{data.message}} 
        <span class="closeNotification fr"(click)="snackBarRef.dismiss()"><img src="/assets/img/close.svg"></span>
        <div class="clear"></div>
    </div>
</div>